
import { mapGetters, mapMutations } from 'vuex'
import * as ov from '@/constants/constants'

var path = '/new-order'

export default {
  head() {
    return {
      title: this.pageData.metatitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageData.metadesc,
        }
      ],

      bodyAttrs: {
        class: 'personal',
      },

    }
  },

  data() {
    return {
      pageData: null,

      text_input: null,
      title_input: null,
      genre_input: null,
      // mood_input: null,
      // speed_input: null,
      topic_input: null,
      urgent_input: false,
      file_input: null,
      link_input: null,
      link_edit: false,

      dogovor_needed: false,

      clip_length_input: null,

      options: [],

      comment_opened: false,
      comment_added: false,
      comment_files_added: false,
      // comment_files: [{ 'file_name': '' }],
      // comment_text: '',

      orderfile_too_big: false,

      loading: false,
    };
  },

  asyncData(context) {
    if (context.store.getters.isAuthenticated) {
      if (['narrator'].includes(context.store.state.auth.user.role)) {
        context.redirect(301, context.localePath('profile-orders'))
        return
      }
      if (['agent'].includes(context.store.state.auth.user.role)) {
        context.redirect(301, context.localePath('profile-settings'))
        return
      }
    }

    return context.$axios
      .get(path)
      .then((res) => {
        return { pageData: res.data }
      })
  },

  methods: {
    suggestOrder() {
      // this.loading = true
      if (typeof ym !== 'undefined') ym(94196688, 'reachGoal', 'order_submit');
      // console.log('suggestOrder order_submit')
      this.$root.$emit('open-modal', { modal: 'pay-not-logged', was_not_logged: !this.isAuthenticated })
      // this.loading = false
    },

    sendForCalc() {
      this.loading = true
      if (typeof ym !== 'undefined') ym(94196688, 'reachGoal', 'order_submit');
      // console.log('sendForCalc order_submit')      
      this.saveOrder(ov.ORDER_WAITING_CALC)
      // this.loading = false
    },

    saveOrder(status = ov.ORDER_DRAFT, payment_method = null, company = null) {
      // console.log('new-order saveOrder', status, payment_method, company)
      if (this.isAuthenticated && (this.loggedInUser.role == 'client') && this.storeOrder.narrator) {
        this.$store.dispatch('setOrderPrices')
        this.$store.commit('setOrderStatus', ov.ORDER_DRAFT)
        if (payment_method) this.$store.commit('setOrderPaymentMethod', payment_method)

        this.$axios
          .post('/client/orders',
            this.storeOrder,
          )
          .then((res) => {
            // console.log(res)
            var order_id = res.data.id



            var draftPromise = new Promise((draftRes) => {

              if (document.querySelector('[name="neworder_comment_text"]')) {
                var comment_text = document.querySelector('[name="neworder_comment_text"]').value
              }
              var comment_files = document.querySelectorAll('[name="commentfile[]"]')

              if (comment_text || (comment_files.length > 1)) {
                var formData = new FormData();
                formData.append('text', comment_text)
                comment_files.forEach((el, i) => {
                  if (typeof el.files[0] !== 'undefined') formData.append("file[]", el.files[0])
                })

                this.$axios
                  .post(`/client/orders/${order_id}/comments`,
                    formData,
                    {
                      headers: {
                        'Content-Type': 'multipart/form-data'
                      }
                    }
                  )
                  .then((res1) => {
                    draftRes(true)
                  })
              }
              else {
                draftRes(true)
              }
            })



            const statusPromise = draftPromise.then((statusRes) => {
              this.$store.commit('toggleOrderProtectionFromCleaning', false)
              // this.$store.commit('initOrder')

              if (status == ov.ORDER_DRAFT) {
                this.$router.push(this.localePath('profile-orders-drafts'))
              }
              else {
                this.$axios
                  .put(`/${this.$store.getters.loggedInUser.role}/orders/${order_id}/state`, {
                    status: status,
                    params: {
                      'method': payment_method,
                      'company': company,
                    },
                  })
                  .then((res1) => {
                    if (res1.data.confirmation_url) {
                      window.location.href = res1.data.confirmation_url
                    }

                    if (res1.data.invoice_content) {
                      // this.$root.$emit('open-modal', { modal: 'notify', message: this.$t('invoice-generated'), link: res1.data.invoice_link, link_title: this.$t('link') })
                      // let pdfcontent = Buffer.from(res1.data.invoice_content, 'base64')
                      // let a = document.createElement("a");
                      // let file = new Blob([pdfcontent], { type: 'application/pdf' });
                      // a.href = URL.createObjectURL(file);
                      // a.download = `invoice_${res1.data.payment_id}.pdf`;
                      // a.click();
                      this.$router.push(this.localePath('profile-orders') + '/' + order_id)
                    }

                    if (!res1.data.confirmation_url && !res1.data.invoice_content) {
                      this.$router.push(this.localePath('profile-orders') + (res1.data.payment_id ? '?pid=' + res1.data.payment_id : ''))
                    }

                    this.$root.$emit('refresh-orders', [])

                  })
              }
            })

          })
      }
      else {
        // console.log('not auth')
        if (status == ov.ORDER_DRAFT) this.$root.$emit('open-modal', { modal: 'save-draft' })
        else {
          if (this.canSendForCalc) this.$root.$emit('open-modal', { modal: 'calc-order-not-logged' })
        }
      }
    },

    deleteLink() {
      this.link_input = ''
      this.link_edit = false
      this.$store.commit('setOrderLink', '')
    },

    unsetUrgent() {
      this.urgent_input = 0
    },


    openFileSelect() {
      var input = this.$refs.orderFile
      input.click()
    },

    fileSelected() {

      this.orderfile_too_big = false
      var selectedFile = document.querySelector('#orderFile')

      if (selectedFile.files[0].size > 100 * 1024 * 1024) {
        this.orderfile_too_big = true
        return
      }

      // console.log('selected')
      // this.price_input = 0
      this.text_input = ''
      this.$store.commit('setOrderPrice', 0)

      // if (selectedFile.files[0].type != 'image/jpeg') {
      //   //TODO wrong format
      // }

      var formData = new FormData();
      formData.append("file", selectedFile.files[0]);
      this.$axios
        .post('/file',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((res) => {
          // console.log(res)
          this.$store.commit('setOrderFile', res.data.file)

        })
    },

    removeOrderFile() {
      this.$axios
        .delete(`/file/${this.storeOrder.file.id}`)
        .then((res) => {
          // console.log(res)
          this.$store.commit('setOrderFile', null)
        })
    },

    openComment() {
      this.comment_opened = true
    },

    // newComment(data) {
    //   console.log('newComment')
    //   this.comment_files = data.files
    //   this.comment_text = data.text
    //   console.log(document.querySelectorAll('[name="commentfile[]"]'))
    // },

    changeComment(data) {
      // console.log(data)
      this.comment_added = data && 1
    },

    changeCommentFiles(data) {
      this.comment_files_added = data && 1
    },

    removeComment(data) {
      this.$store.commit('clearOrderComments')
      this.comment_added = false
      this.comment_files_added = false
    },

    removeOrderMusic(id) {
      this.$store.commit('removeOrderMusic', id)
      // this.$root.$emit('music_updated')
    },

    narratorClear() {
      this.$store.commit('setOrderNarrator', { id: null })
    },

    setOrClearTopic(topic_id) {
      // console.log(topic_id+' '+this.topic_input)
      if (this.topic_input == topic_id) this.topic_input = 0; else this.topic_input = topic_id
    },

    initVars() {
      // console.log(this.storeOrder)
      this.title_input = this.storeOrder.title
      this.text_input = this.storeOrder.text
      this.genre_input = this.storeOrder.genre.id
      this.dogovor_needed = this.storeOrder.dogovor_needed
      // this.mood_input = this.storeOrder.mood
      // this.speed_input = this.storeOrder.speed
      this.topic_input = this.storeOrder.topic
      this.urgent_input = this.storeOrder.urgent
      this.file_input = this.storeOrder.file
      // this.price_input = this.storeOrder.price
      this.clip_length_input = this.storeOrder.clip_length

      this.link_input = this.storeOrder.link
      this.link_edit = this.storeOrder.link || 0
    },

    selectNarrator() {
      this.$root.$emit('open-modal', { modal: 'narrators' })
    },

  },

  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser', 'storeOrder', 'appInfo']),

    ov() {
      return ov
    },

    orderGenre() {
      return Object.values(this.appInfo.genres).find(el => el.id === this.storeOrder.genre.id)
    },

    narratorImage() {
      return this.storeOrder.narrator.image ? this.storeOrder.narrator.image : ov.DEFAULT_IMAGE
    },

    isLinkValid() {
      return this.link_input &&
        (
          (this.link_input.indexOf('http://') + 1)
          || (this.link_input.indexOf('https://') + 1)
          || (this.link_input.indexOf('www') + 1)
          || (this.link_input.indexOf('.com') + 1)
          || (this.link_input.indexOf('.ru') + 1)
        )
    },

    isContentLoaded() {
      return this.isTextFilled || (this.storeOrder.file !== null) || this.isLinkValid
    },

    isSomethingDone() {
      return this.isContentLoaded || this.isNarratorSet || this.storeOrder.musics.length
    },

    readyToOrder() {
      return this.isNarratorSet
        && (this.isTextFilled || this.storeOrder.file || this.storeOrder.link)
        && this.getPrice
        && ((this.urgent_input == 0) || this.storeOrder.narrator.urgent)
        && this.storeOrder.genre
        // && this.storeOrder.mood
        // && this.storeOrder.speed
        && !this.cannotTopic
      // && !this.cannotOffframe
    },

    canSaveOrder() {
      return this.isNarratorSet
    },

    canOnlyBeCalculated() {
      return this.orderGenre.only_to_calculate || (this.isLinkOrFile && !this.isTextFilled) || (this.isTextFilled && !this.getPrice)
    },

    showCalcButton() {
      return this.isNarratorSet && this.canOnlyBeCalculated
      // && (
      //   this.isLinkOrFile
      //   || (this.isTextFilled && !this.getPrice)
      // )
    },

    showOrderButton() {
      return !this.orderGenre.only_to_calculate
        && (
          !this.isNarratorSet
          || (this.isNarratorSet && this.isTextFilled && this.getPrice)
          || (this.isNarratorSet && !this.isLinkOrFile && !this.isTextFilled)
        )
    },

    canSendForCalc() {
      return this.isNarratorSet
        && ((this.urgent_input == 0) || this.storeOrder.narrator.urgent)
        && (this.isLinkOrFile || (this.isTextFilled && !this.getPrice))
        && !this.cannotTopic
        && (!((this.storeOrder.genre.id == ov.GENRE_OFFFRAME) || (this.storeOrder.genre.id == ov.GENRE_YOUTUBE)) || parseInt(this.clip_length_input))
      // && !this.cannotOffframe
    },

    isTextFilled() {
      if (this.text_input === null) return false

      let trimmedText = this.text_input.trim()
      let regexpForText = /\S{3,}/;

      return regexpForText.test(trimmedText)
    },

    isLinkOrFile() {
      return ((this.storeOrder.file !== null) || this.isLinkValid)
    },

    isMusicAdded() {
      return this.storeOrder.musics && this.storeOrder.musics.length
    },

    getPrice() {
      return this.$store.getters.totalPrice()
    },

    isNoCommentYet() {
      return !this.firstTextComment
    },

    firstTextComment() {
      if (typeof this.storeOrder.ordermessages === 'undefined') return null
      var messages = this.storeOrder.ordermessages.filter(item => !item.service)
      if (messages.length) return messages.slice(0, 1); else return null
    },

    cannotTopic() {
      return this.isNarratorSet && this.storeOrder.narrator.topics && this.storeOrder.narrator.topics.find(item => item.id === this.topic_input)
    },





    computedAddTextLabel() {
      let label = this.$t('add-text')
      if (this.storeOrder.genre && this.storeOrder.genre.id && this.storeOrder.genre.id == ov.GENRE_AUDIOBOOK) {
        label = this.$t('attach-text')
      }
      return label
    },

    isNarratorSet() {
      return this.storeOrder.narrator && this.storeOrder.narrator.id
    },

    genreObject() {
      return Object.values(this.appInfo.genres).find(el => el.id == this.genre_input)
    },

  },

  watch: {
    text_input: function (val, oldVal) {
      this.orderfile_too_big = false
      this.$store.commit('setOrderText', val)

      var text_time
      const speed = 2//this.storeOrder.speed ? this.storeOrder.speed : 2
      if (speed == 1) text_time = this.storeOrder.time_slow
      if (speed == 2) text_time = this.storeOrder.time_optimal
      if ((speed == 3) || (speed == 4)) text_time = this.storeOrder.time_fast
      const seconds = text_time
      const minutes = Math.ceil(seconds / 60)


      // переход на другой жанр при выходе за рамки времени
      if (this.genreObject.max_seconds) {
        if (seconds > this.genreObject.max_seconds) {
          this.genre_input = this.genreObject.set_if_more_max
        }
      }

      if (this.genreObject.min_seconds) {
        if (seconds <= this.genreObject.min_seconds) {
          this.genre_input = this.genreObject.set_if_less_min
        }
      }


    },

    title_input: function (val, oldVal) {
      this.$store.commit('setOrderTitle', val)
    },

    genre_input: function (val, oldVal) {
      this.dogovor_needed = false
      this.$store.commit('setOrderGenre', val)
    },

    // mood_input: function (val, oldVal) {
    //   this.$store.commit('setOrderMood', val)
    // },

    // speed_input: function (val, oldVal) {
    //   this.$store.commit('setOrderSpeed', val)
    // },

    topic_input: function (val, oldVal) {
      this.$store.commit('setOrderTopic', val)
    },

    urgent_input: function (val, oldVal) {
      this.$store.commit('setOrderUrgent', val)
    },

    dogovor_needed: function (val, oldVal) {
      this.$store.commit('setOrderDogovorNeeded', val)
    },

    file_input: function (val, oldVal) {
      if (val) {
        this.text_input = ''
        // this.genre_input = 2
      }
      this.$store.commit('setOrderFile', val)
    },

    link_input: function (val, oldVal) {
      if (val) {
        this.text_input = ''
        // this.genre_input = 4
      }
      this.$store.commit('setOrderLink', val)
    },

    clip_length_input: function (val, oldVal) {
      this.$store.commit('setOrderCliplength', val)
    },

  },

  created() {
    this.$store.commit('initOrder')
    this.$store.commit('toggleOrderProtectionFromCleaning', false)

    if (this.$route.query.id) {
      this.$axios
        .get('/client/orders/id/' + this.$route.query.id, {
        })
        .then((res) => {
          res.data.order.genre.id = res.data.order.genres_id
          res.data.order.mood = res.data.order.moods_id
          res.data.order.speed = res.data.order.speeds_id
          res.data.order.topic = res.data.order.topics_id
          res.data.order.dogovor_needed = res.data.order.dogovor_needed
          // console.log(res.data.order)
          this.$store.commit('setOrderAll', res.data.order)
          this.$store.commit('toggleOrderProtectionFromCleaning', false)
          this.initVars()

          if ((res.data.order.prevstatus_id == ov.ORDER_SUGGESTED) || (res.data.order.prevstatus_id == ov.ORDER_WAITING_CALC) || (res.data.order.prevstatus_id == ov.ORDER_CALCULATED)) {
            this.$nextTick(function () {
              this.$root.$emit('open-modal', { modal: "notify", message: (this.loggedInUser.role == 'client' ? this.$t('notify_status_4_for_client') : this.$t('notify_status_4')) })
            })
          }
        })
    }
    else {
      this.initVars()
    }

    // this.$root.$on('music_updated', () => {
    // })

    this.$root.$on('save_order', (status = null, payment_method = null, company = null) => {
      this.saveOrder(status, payment_method, company)
    })
  },

  beforeDestroy() {
    this.$root.$off('save_order')
    // this.$root.$off('music_updated')
  },

}
